var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 20",
    style: {
      enableBackground: "new 0 0 24 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#042b62;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,1.1c0.9,0,1.7,0.7,1.7,1.7S12.9,4.4,12,4.4s-1.7-0.7-1.7-1.7S11.1,1.1,12,1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,0.1c1,0,1.7,0.8,1.7,1.7S5.1,3.6,4.2,3.6S2.4,2.8,2.4,1.8S3.2,0.1,4.2,0.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,15.2l-2-3.8c-0.1-0.2-0.3-0.3-0.6-0.3h-1.8c-0.1,0-0.1,0-0.2,0L16.9,11c0,0,0-0.1-0.1-0.1 c0,0-2.8-5.5-2.9-5.5C13.8,5.1,13.6,5,13.3,5h-2.8c-0.3,0-0.5,0.1-0.6,0.3c0,0.1-1.1,2.1-1.8,3.5L7.9,4.9c0-0.4-0.4-0.8-0.8-0.7H1.3 c-0.4,0-0.8,0.3-0.8,0.7L0,11.4c0,0.4,0.3,0.8,0.7,0.9c0.4,0,0.8-0.3,0.9-0.7l0.3-4.4l0,11.3c0,0.5,0.4,1,0.9,1c0.6,0,1-0.4,1-1v-6 c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.4,0.1,0.4,0.3v6c0,0.5,0.4,1,0.9,1c0.6,0,1-0.4,1-1l0-11.1l0.3,4.2c0,0.4,0.4,0.7,0.8,0.7 c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,1.6-3,1.6-3L9.3,13c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.4,0.2v4.8c0,0.5,0.4,0.9,0.9,0.9 c0.5,0,0.9-0.4,0.9-0.9V14c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3v4.5c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9v-4.9 c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.1-0.4l-0.5-4.1l1.3,2.6c0.1,0.3,0.4,0.4,0.7,0.4c0.1,0,0.1,0,0.2,0l2,0.2l-0.6,4.1 c-0.1,0.2,0,0.4,0.2,0.6c0.1,0.1,0.2,0.1,0.3,0.1h0.1v1.9c0,0.3,0.2,0.6,0.6,0.6c0.4,0,0.7-0.3,0.7-0.6v-1.8c0-0.1,0.1-0.2,0.2-0.2 l0,0c0.1,0,0.2,0.1,0.2,0.2v1.7c0,0.3,0.2,0.6,0.6,0.6c0.4,0,0.7-0.3,0.7-0.6v-2h0.1c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.3-0.4,0.2-0.6 l-0.3-1.9l0.7,1.4c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.2,0,0.2-0.1C23.2,15.7,23.3,15.4,23.2,15.2z M4.8,8L4.3,8.7C4.3,8.8,4,8.8,4,8.7 L3.5,8c0-0.1,0-0.1,0-0.2l0.4-2.1L3.6,5.4c-0.1-0.1-0.1-0.2,0-0.3L4,4.7c0.1-0.1,0.2-0.1,0.3,0l0.4,0.4c0.1,0.1,0.1,0.2,0,0.3 L4.4,5.7l0.4,2.1C4.8,7.9,4.8,7.9,4.8,8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,10.5H18c0.1,0,0.2-0.1,0.2-0.2c0-0.4,0.1-0.8,0.4-1.1c0,0,0,0,0,0.1c0,0.7,0.6,1.3,1.3,1.3 c0.7,0,1.3-0.6,1.3-1.3c0,0,0-0.1,0-0.1c0.2,0.3,0.4,0.7,0.4,1.1c0,0.1,0.1,0.2,0.2,0.2h0.7c0.1,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0-0.1 c-0.1-0.8-0.8-1.5-1.6-1.6c-0.2-0.5-0.7-0.8-1.2-0.8c-0.5,0-1,0.3-1.2,0.8c-0.8,0.1-1.5,0.7-1.6,1.6c0,0.1,0,0.1,0,0.1 C17.2,10.5,17.2,10.5,17.3,10.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuf);
export default __webpack_public_path__ + "static/media/HUF.c98ec5fdd9604184969016ce1532c2e0.svg";
export { ForwardRef as ReactComponent };